// @ts-ignore
import { Localization } from '../../localization/localization';
import { JsFormBeforeSendObject, JsFormResponseHandlerObject } from '../modules/jsFormTypes.js';
import { ErrorToolTip, TooltipDirection } from '../newErrorToolTip';
import { FormHandlers } from '../modules/formHandlers';
import { requestEmailOtpAuth,
    RequestEmailOtpAuthRequest,
    RequestEmailOtpResponse } from '../modules/otp/requestEmailOtpAuth';
import { PopupManager } from '../../popups/popupManager';
import { getUrlToLoginViaToken } from '../../login/getUrlToLoginViaToken';
import { addLoginQueryParams } from '../../utils/url';
import { appendUnityLoginIframe } from '../../utils/landing';
import { confirmEmailOtpAuth,
    ConfirmEmailOtpAuthRequest,
    ConfirmEmailOtpAuthResponse } from '../modules/otp/confirmEmailOtpAuth';
import { CustomJrpcErrResult } from '../modules/jsonRpc/jRpcErrResponse';

let otpEmail :string|null = null;

function otpRequestCodeSendHandler(data: JsFormBeforeSendObject) {
    const emailField = $('input[name=email]', data.form);
    const input = emailField.parent();
    let toolTipDirection;

    if (emailField.length === 0 || emailField.val().toString().length === 0) {
        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            toolTipDirection,
            Localization._n('errors.email_empty')
        );
        return false;
    }

    if (state.allowResend && state.allowResend > new Date().getTime()) {
        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            toolTipDirection,
            Localization._n('otp_request_code.wait_30')
        );
        return false;
    }

    return true;
}
const state = {
    allowResend: 0,
    isResend: false
};

let countDown: number;

function updateCounter() {
    const now = new Date().getTime();
    const delta = state.allowResend ? state.allowResend - now : 0;
    if (delta < 0) {
        clearInterval(countDown);
        displayReturnText();
        return;
    }
    updatePopupText(delta);
}

function displayReturnText() {
    $('.otp-resend-info').html(Localization._n('accounting.OTP_window.resend_code'));
    $('.otp-resend-info a').on('click', function(e) {
        e.preventDefault();
        resendOtp();
    });
}

const SECOND_DELTA_NUMERATOR = 1000 * 60;
const SECOND_DELTA_DENOMINATOR = 1000;

function updatePopupText(delta:number) {
    const minutes = Math.floor(delta / SECOND_DELTA_NUMERATOR);
    let seconds:number|string = Math.ceil((delta % SECOND_DELTA_NUMERATOR) / SECOND_DELTA_DENOMINATOR);
    if (seconds < 10) {
        seconds = `0${seconds}`;
    }
    let translationKey = '';
    if (state.isResend) {
        translationKey = 'accounting.OTP_window.code_resend_resend_code_after';
    } else {
        translationKey = 'accounting.OTP_window.resend_code_after';
    }
    $('.otp-resend-info').html(Localization._n(
        translationKey,
        {
            minutes: `${minutes}`,
            seconds: `${seconds}`
        }
    ));
}

function otpRequestCodeFormAfterHandler(data: JsFormResponseHandlerObject<RequestEmailOtpResponse>) {
    const response = data.response;
    let toolTipDirection = TooltipDirection.RIGHT;
    const input = $('input[name=email]', data.form).parent();
    if (!('error' in response)) {
        const descriptionText = $('.otp-login-info');
        descriptionText.html(Localization._n('accounting.OTP_window.description', {value: otpEmail}));
        const delay = window.app.config?.otp?.delay ?? 1000 * 60;
        state.allowResend = new Date().getTime() + delay;
        updateCounter();
        if (countDown) {
            clearInterval(countDown);
        }
        countDown = window.setInterval(() => {
            updateCounter();
        }, 1000);
        window.app.closeAndOpenPopup({
            hideclass: 'popup2',
            alignoff: true,
            id: data.caller[0].dataset.id
        });
        $('.pin-input').val('');
        PopupManager.openSingle('otp_email_login');
    } else {
        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            toolTipDirection,
            response.error.message
        );

        input.addClass('error');
    }
}

function otpRequestCodeFormSendRequest(form: JQuery): Promise<RequestEmailOtpResponse> {
    const email = $(form).find('input[name=email]')
        .val()
        .toString()
        .trim();
    const newOtpRequest: RequestEmailOtpAuthRequest = {
        email,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    otpEmail = email;
    return requestEmailOtpAuth(newOtpRequest);
}

function otpConfirmCodeSendHandler(data: JsFormBeforeSendObject) {
    const otpValue = $('.pin-input', data.form).toArray()
        .map((input: HTMLInputElement) => input.value)
        .join('');
    if (otpValue.length !== 6) {
        const input = $('.pin-container', data.form);
        let toolTipDirection;

        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            toolTipDirection,
            Localization._n('otp_request_code.not_full')
        );
        return false;
    }

    return true;
}

function otpConfirmCodeFormAfterHandler(data: JsFormResponseHandlerObject<ConfirmEmailOtpAuthResponse | CustomJrpcErrResult>) {
    const response = data.response;
    let toolTipDirection = TooltipDirection.RIGHT;
    const input = $('.pin-container', data.form);
    if (!('error' in response)) {
        let url = getUrlToLoginViaToken(response?.tether.token, response?.tether.suid);
        url = addLoginQueryParams(url);
        appendUnityLoginIframe(url);
    } else {
        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            toolTipDirection,
            response?.error.code === 13 ? Localization._n('otp_confirm.wrong_otp') : response.error.message
        );

        input.addClass('error');
    }
}

function otpConfirmCodeFormSendRequest(form: JQuery): Promise<ConfirmEmailOtpAuthResponse | CustomJrpcErrResult> {
    const otpValue = $('.pin-input', form).toArray()
        .map((input: HTMLInputElement) => input.value)
        .join('')
        .toUpperCase();
    if (!otpEmail) {
        window.app.closeAndOpenPopup({
            hideclass: 'popup2',
            alignoff: true,
            id: 'otp_request_code2'
        });
        PopupManager.openSingle('otp_request_code');
    }
    const confirmEmailOtpRequest: ConfirmEmailOtpAuthRequest = {
        email: otpEmail,
        otp: otpValue,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    return confirmEmailOtpAuth(confirmEmailOtpRequest);
}

async function resendOtp() {
    $('.pin-input').val('');
    state.isResend = true;
    state.allowResend = new Date().getTime() + 1000 * 30;
    updateCounter();
    const newOtpRequest: RequestEmailOtpAuthRequest = {
        email: otpEmail,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    const res = await requestEmailOtpAuth(newOtpRequest);
    if ('error' in res) {
        state.allowResend = 0;
        updateCounter();
        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('.otp-resend-info a'),
            TooltipDirection.RIGHT,
            res.error.message
        );
    } else {
        if (countDown) {
            clearInterval(countDown);
        }
        countDown = window.setInterval(() => {
            updateCounter();
        }, 1000);
    }
}

export function initOtpForm() {
    FormHandlers.registerAfterSendHandler('otp_request_code_form_handler', otpRequestCodeFormAfterHandler);
    FormHandlers.registerBeforeSendHandler('before_otp_request_code', otpRequestCodeSendHandler);
    FormHandlers.registerSendRequestHandler('otp_request_code_send_request', otpRequestCodeFormSendRequest);
    FormHandlers.registerAfterSendHandler('otp_confirm_code_form_handler', otpConfirmCodeFormAfterHandler);
    FormHandlers.registerBeforeSendHandler('before_otp_confirm_code', otpConfirmCodeSendHandler);
    FormHandlers.registerSendRequestHandler('otp_confirm_code_send_request', otpConfirmCodeFormSendRequest);
    const inputContainer = document.querySelectorAll('.pin-container');
    inputContainer.forEach((inputContainer) => {
        const inputs: NodeListOf<HTMLInputElement> = inputContainer.querySelectorAll('.pin-input');
        inputs.forEach(function(input, index) {
            input.addEventListener('input', function() {
                if (this.value.length >= this.maxLength) {
                    if (index < inputs.length - 1) {
                        // @ts-ignore
                        inputs[index + 1].focus();
                    }
                }
            });

            input.addEventListener('keydown', function(event) {
                // @ts-ignore
                if (event.key === 'Backspace' && this.value.length === 0) {
                    if (index > 0) {
                        // @ts-ignore
                        inputs[index - 1].focus();
                    }
                }
            });
            input.addEventListener('paste', (event: ClipboardEvent) => {
                const paste = event.clipboardData.getData('text');
                inputs.forEach((input, i) => input.value = paste[i] || '');
            });
        });
    });
}
